import { render, staticRenderFns } from "./newsConsult.vue?vue&type=template&id=7cfa210d&scoped=true&"
import script from "./newsConsult.vue?vue&type=script&lang=js&"
export * from "./newsConsult.vue?vue&type=script&lang=js&"
import style0 from "./newsConsult.vue?vue&type=style&index=0&id=7cfa210d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfa210d",
  null
  
)

export default component.exports